import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { Routes } from '../routes/RouteConstants';
import { HEADER_HEIGHT_NARROW_PX, HEADER_HEIGHT_PX } from '../layouts/layoutMetrics';
import { TOPBAR_HEIGHT } from '../features/dashboard/layout/adminSections';

// A success is read at a glance; an error says what to do next, and gets longer. Anything else (the
// site's info notice) stays until it is closed.
const HIDE_AFTER_MS = { success: 3000, error: 5000 };

const GAP_PX = 12;

/**
 * Where the message stands: under the bar of the page it is on, never over it. In the bar's corner
 * it covered the profile menu, and an error stayed there until closed.
 *
 * The provider is mounted above the router, so the page is read from the address itself.
 */
const topOffsetSx = () => {
  const { pathname } = window.location;
  const isAdminArea = pathname === Routes.DASHBOARD || pathname.startsWith(`${Routes.DASHBOARD}/`);
  const narrow = `${(isAdminArea ? TOPBAR_HEIGHT : HEADER_HEIGHT_NARROW_PX) + GAP_PX}px`;
  const wide = `${(isAdminArea ? TOPBAR_HEIGHT : HEADER_HEIGHT_PX) + GAP_PX}px`;

  // `sm` is named too: MUI sets its own top from there up, which a plain value would lose to.
  return { top: { xs: narrow, sm: narrow, md: wide } };
};

const CustomSnackbar = ({ open, setOpen, message, severity = "error" }) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={HIDE_AFTER_MS[severity] ?? null}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={topOffsetSx()}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{ width: '100%'}}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
